







































import _ from 'lodash'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'

@Component
export default class ScaleSelectionComponent extends Vue {
  @Prop() public size!: number
  @Prop({default: 'top'}) public align!: string
  @Prop({default: 'top'}) public iconalign!: string

  public template = null
  public scale = {
    width: 0,
    height: 0,
  }
  public tabsCollection: Array<
    {
      width: number,
      collection: Array<{ icon: string, width: number, height: number }>,
    }
  > = [
    {
      width: 0,
      collection: [
        { icon: 'cellphone-iphone', width: 320, height: 568 },
        { icon: 'tablet-ipad', width: 768, height: 1024 },
        { icon: 'laptop', width: 1280, height: 850 },
      ],
    },
    {
      width: 480,
      collection: [
        { icon: 'cellphone-iphone', width: 320, height: 568 },
        { icon: 'cellphone-iphone', width: 414, height: 896 },
        { icon: 'tablet-ipad', width: 768, height: 1024 },
        { icon: 'laptop', width: 1280, height: 850 },
        { icon: 'monitor', width: 1440, height: 900 },
      ],
    },
    {
      width: 600,
      collection: [
        { icon: 'cellphone-iphone', width: 320, height: 568 },
        { icon: 'cellphone-iphone', width: 414, height: 896 },
        { icon: 'tablet-ipad', width: 768, height: 1024 },
        { icon: 'tablet-ipad', width: 834, height: 1112 },
        { icon: 'laptop', width: 1280, height: 850 },
        { icon: 'monitor', width: 1440, height: 900 },
      ],
    },
    {
      width: 1000,
      collection: [
          { icon: 'cellphone-iphone', width: 320, height: 568 },
          { icon: 'cellphone-iphone', width: 375, height: 812 },
          { icon: 'cellphone-iphone', width: 414, height: 896 },
          { icon: 'tablet-ipad', width: 768, height: 1024 },
          { icon: 'tablet-ipad', width: 834, height: 1112 },
          { icon: 'laptop', width: 1280, height: 850 },
          { icon: 'monitor', width: 1366, height: 768 },
          { icon: 'monitor', width: 1440, height: 900 },
      ],
    },
  ]
  public tabs: Array<{[key: string]: string | number}> = []
  public tabsModel = {}
  public tabModel = 0

  private mounted() {
    this.init()
  }

  private init() {
    this.tabs = this.getCollectionTab(this.size)
    this.tabsModel = {}
    if (_.isEmpty(this.tabs)) {
      setTimeout(() => {
        this.init()
      }, 500)
    } else {
      this.tabModel = _.floor((_.size(this.tabs)) / 2)
      this.tabsModel = this.tabs[this.tabModel]
    }
  }

  private getCollectionTab(fixWidth?: number) {
    const tabPreviewContent = document.getElementById('tabPreviewContent')
    const width = tabPreviewContent ? tabPreviewContent.clientWidth : 0
    const collet = _.findLast(this.tabsCollection, (c) => {
      return (fixWidth || width) > c.width
    })
    return (collet && collet.collection) || []
  }

}
